import React, { Component } from "react";
import Rating from "react-star-rating-component";
import * as aaUtil from "../../utils/aaUtils";

import "./AthReviewModal.css";

class AthReviewModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rating: 0,
      comment: "",
      showError: false
    };
  }

  handleRatingClick = (nextValue, prevValue, name) => {
    if (this.state.showError) this.setState({ showError: false });
    this.setState({ rating: nextValue });
  };

  handleComment = e => {
    this.setState({ comment: e.target.value });
  };

  submitReview = () => {
    this.setState({ showError: false });
    if (this.state.rating === 0) {
      this.setState({ showError: true });
      return;
    }
    this.props.sendReview(this.state.rating, this.state.comment);
    const source = window.location.pathname.includes("/ath/") ? "(P1)" : "(P2)";
    aaUtil.event17_submit_review(this.state.rating, source);
    this.props.onCloseReviewModal();
  };

  render() {
    return (
      <div className="ath-review-modal">
        <div className="ath-review-modal__section ath-review-modal__header-section">
          <h3 className="ath-review-modal__header">Give us a Rating</h3>
          <div className="ath-review-modal__header-subtitle">
            To win a set of personalized hair care products (worth $50+)
          </div>
        </div>
        <div className="ath-review-modal__section ath-review-modal__star-section">
          <h4 className="ath-review-modal__section-header">
            Did you enjoy your personalized experience?
          </h4>
          <Rating
            name="ath-review-modal__star-rating"
            starCount={5}
            renderStarIcon={(index, value) => (
              <span style={{ marginRight: '10px' }}>
                {/* <TiStarFullOutline size={14} /> */}
                <i className={index <= value ? 'fa fa-star' : 'fa fa-star-o'} style={{fontSize:'39px'}} />
              </span>
            )}
            starColor="#ffad94"
            emptyStarColor="#ffad94"
            value={this.state.rating}
            onStarClick={this.handleRatingClick}
          />
        </div>
        <div className="ath-review-modal__section ath-review-modal__comment-section">
          <h4 className="ath-review-modal__section-header">
            Do you have any additional comments or questions?
          </h4>
          <textarea
            className="ath-review-modal__comment"
            value={this.state.comment}
            onChange={this.handleComment}
          />
          {this.state.showError ? (
            <p className="ath-review-modal__error">Please enter a rating.</p>
          ) : null}
        </div>

        <div className="ath-review-modal__section ath-review-modal__button-section">
          <button
            onClick={this.submitReview}
            className="ath-review-modal__button"
          >
            Submit
          </button>
        </div>
      </div>
    );
  }
}

export default AthReviewModal;



// WEBPACK FOOTER //
// ./src/ath/components/recommendations/AthReviewModal.js